<script>
    import { afterUpdate, onMount, createEventDispatcher } from 'svelte';
    import { next_session, user, break_session } from './stores.js';
    import LiveVideo from './components/LiveVideo.svelte';
    import Chat from './Chat.svelte';


    let w;
    let breakpoint = 768;
    let timer;

	afterUpdate(() => {
		console.log("after update");
        if (timer) {
            timer.restart($next_session);
        }
	});

</script>
<svelte:window bind:innerWidth={w}/>

<section>
    <!-- <dwane-timer bind:this={timer} timer-deadline={$next_session} countdown-start="3600000" timer-orientation="{w < breakpoint ? 'horizontal' : 'vertical'}"></dwane-timer> -->
    <LiveVideo videoSrc={$break_session.livestream}  />
    <!-- <LiveVideo videoSrc="https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8" /> -->
    <!-- <LiveVideo videoSrc="https://cdn-broadcast107-iad.tokbox.com/14517/14517_84ebf190-b319-43fb-80ee-963a92b05532.smil/playlist.m3u8"  /> -->
    <div id="chatQ">
        <dwane-timer bind:this={timer} timer-deadline={$next_session} countdown-start="3600000" timer-orientation="horizontal"></dwane-timer>
        <!-- <Chat eventId = {event.id.stringValue}/> -->
        <Chat/>
    </div>
</section>

<style>
    section {
        height: 100%;
        display:grid;
        grid-template-areas:
			"liveVideo"
			"chatQ"

    }

    LiveVideo {
        grid-area: liveVideo;
    }

    #chatQ {
        grid-area: chatQ;
        height: 100%;
        text-align: center;
    }

    dwane-timer {
        --dwane-timer-font-family: "Roboto Mono";
        --dwane-timer-weekday-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-date-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-time-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-countdown-font-size: clamp(5rem, 1.5vw, 9rem);
        --dwane-timer-text-color: black;
        opacity: 0;
        transition:opacity 0.4s ease-in;
        grid-area: timer;
    }

    dwane-timer:defined {
        opacity: 1;
    }

    @media (min-width: 768px) {
		section {
			grid-template-columns: 3fr 1fr;
			grid-template-areas:
				"liveVideo chatQ"
		}
	}

</style>